<div class="container" *ngIf="finishedLoadingUsers">
    <div class="row marginBottom2Rem">
        <div class="offset-lg-12">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Kundenkarten Haushalt</mat-card-title>
                </mat-card-header>
            </mat-card>

            <div class="row">
                <div class="col-sm-12">
                    <div class="example-container mat-elevation-z2">
                        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                            <ng-container matColumnDef="number">
                                <th mat-header-cell *matHeaderCellDef>
                                    #
                                </th>
                                <td mat-cell *matCellDef="let card; let i = index;" class="mat-column">
                                    {{i+1}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="ID">
                                <th mat-header-cell *matHeaderCellDef>
                                    Kennung
                                </th>
                                <td mat-cell *matCellDef="let card" class="mat-column">
                                    <a [routerLink]="['../../../card']"
                                        [queryParams]="{searchTerm:card?.number, filterByState : card.state}">
                                        {{card.number}} ({{card.cardId}})
                                    </a>

                                </td>
                            </ng-container>

                            <ng-container matColumnDef="user">
                                <th mat-header-cell *matHeaderCellDef>
                                    Besitzer
                                </th>
                                <td mat-cell *matCellDef="let card" class="mat-column">
                                    <a [routerLink]="['../../edit', card.ownerPublicId]">

                                        {{card?.userModel?.person?.displayName}}
                                    </a>

                                </td>
                            </ng-container>

                            <ng-container matColumnDef="state">
                                <th mat-header-cell *matHeaderCellDef>
                                    Status
                                </th>
                                <td mat-cell *matCellDef="let card" class="mat-column">
                                    <mat-chip-set>
                                        <mat-chip class="primaryChip" selected *ngIf="card.state == 'ACTIVE' ">
                                            {{card.state | translateState}}
                                        </mat-chip>
                                        <mat-chip disabled *ngIf="card.state != 'ACTIVE' ">
                                            {{card.state | translateState}}
                                        </mat-chip>
                                    </mat-chip-set>
                                </td>
                            </ng-container>


                            <ng-container matColumnDef="date">
                                <th mat-header-cell *matHeaderCellDef>
                                    Erstellt
                                </th>
                                <td mat-cell *matCellDef="let card" class="mat-column">
                                    {{card.created | date : 'dd.MM.yyyy hh:mm'}}
                                </td>
                            </ng-container>


                            <ng-container matColumnDef="last_change">
                                <th mat-header-cell *matHeaderCellDef>
                                    Letzte Änderung
                                </th>
                                <td mat-cell *matCellDef="let card" class="mat-column">
                                    {{card.lastModified | date : 'dd.MM.yyyy hh:mm' }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="menu">
                                <th mat-header-cell *matHeaderCellDef>
                                    Aktion
                                </th>
                                <td mat-cell *matCellDef="let card">
                                    <button mat-icon-button style="margin: 0 auto !important;"
                                        [matMenuTriggerFor]="menu" color="accent">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item [routerLink]="['../../../card']"
                                            [queryParams]="{searchTerm:card?.number, filterByState : card.state}">
                                            <span> Zur Karte </span>
                                        </button>
                                        <button mat-menu-item [routerLink]="['../../edit', card.ownerPublicId]">
                                            <span> Zur Person </span>
                                        </button>

                                        <button mat-menu-item [matMenuTriggerFor]="edit"
                                            [disabled]="card.ownerPublicId == null">Dokumente runterladen</button>
                                        <button mat-menu-item
                                            (click)="startCardProcess('ASSIGN_CARDS',card.ownerPublicId)">
                                            <span> Karten erstmalig drucken </span>
                                        </button>
                                        <button mat-menu-item
                                            (click)="startCardProcess('CLOSE_AND_REASSIGN_CARDS',card.ownerPublicId)">
                                            <span> Karte erneut produzieren </span>
                                        </button>

                                        <button mat-menu-item
                                            (click)="startCardProcess('ASSIGN_CARDS_HOUSEHOLDS', card.ownerPublicId)">
                                            <span> Karten für den Haushalt produzierenn</span>
                                        </button>

                                        <button mat-menu-item (click)="closeCard(card)"
                                            [disabled]="card.ownerPublicId == null"
                                            *ngIf="card.state != 'CLOSED' && card.state != 'CLOSE_REQUEST'">
                                            <span>Karte sperren</span>
                                        </button>

                                        <button mat-menu-item (click)="reopenCard(card)"
                                            [disabled]="card.ownerPublicId == null"
                                            *ngIf="card.state == 'CLOSE_REQUEST'">
                                            <span> Alte Karte wieder freischalten</span>
                                        </button>
                                    </mat-menu>
                                    <mat-menu #edit="matMenu">
                                        <button mat-menu-item (click)="getCardPDF(card)">
                                            <span> Karte (PDF)</span>
                                        </button>
                                        <button mat-menu-item (click)="getCardNotificationPDF(card)">
                                            <span> Kartenanschreiben (PDF)</span>
                                        </button>
                                    </mat-menu>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                        </table>
                        <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">
                            Keine passenden Einträge gefunden...
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row marginBottom2Rem">
        <div class="offset-lg-12">
            <div class="row">
                <div class="col-sm-12">
                    <button mat-button mat-raised-button color="accent" (click)="downloadAllFiles('1')">
                        Alle Kartenanschreiben (PDFs) herunterladen

                    </button>
                    <button mat-button mat-raised-button color="accent"  style="margin-left: 15px;" (click)="downloadAllFiles('2')">
                        Alle Karten (PDFs) herunterladen

                    </button>
                    <button mat-button mat-raised-button color="accent" style="margin-left: 15px;"(click)="downloadAllFiles('3')">
                        Alle Dokumente (PDFs) herunterladen

                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="row marginBottom2Rem">
        <div class="offset-lg-12">
            <div class="row">
                <div class="col-sm-12">
                    <h4>Exportierte Dateien
                    </h4>
                </div>
            </div>

            <div class="row" *ngIf="finishedLoadingFiles">
                <div class="col-sm-12">
                    <div class="example-container mat-elevation-z2">
                        <table mat-table [dataSource]="dataSourceFiles" matSort class="mat-elevation-z2">
                            <ng-container matColumnDef="number">
                                <th mat-header-cell *matHeaderCellDef>
                                    #
                                </th>
                                <td mat-cell *matCellDef="let card; let i = index;" class="mat-column">
                                    {{i+1}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef>
                                    Typ
                                </th>
                                <td mat-cell *matCellDef="let card" class="mat-column">
                                    {{card.processType | translateState}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef>
                                    Dateiname
                                </th>
                                <td mat-cell *matCellDef="let card" class="mat-column ">
                                    {{card.name | truncate : 100 : false}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="size">
                                <th mat-header-cell *matHeaderCellDef>
                                    Größe
                                </th>
                                <td mat-cell *matCellDef="let card" class="mat-column">
                                    {{card.size}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="date">
                                <th mat-header-cell *matHeaderCellDef>
                                    Vom
                                </th>
                                <td mat-cell *matCellDef="let card" class="mat-column">
                                    {{card.lastModified | date : 'hh:mm:ss dd.MM.YYYY'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="menu">
                                <th mat-header-cell *matHeaderCellDef>
                                    Aktion
                                </th>
                                <td mat-cell *matCellDef="let card" class="mat-column">
                                    <button mat-icon-button style="margin: 0 auto !important;"
                                        [matMenuTriggerFor]="menu" color="accent">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item (click)="saveFile(card)"> Lokal speichern</button>
                                    </mat-menu>


                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsFiles; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsFiles;let i = index"></tr>
                        </table>
                        <span *ngIf="dataSourceFiles?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine
                            passenden
                            Einträge
                            gefunden...</span>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="!finishedLoadingFiles">
                <div class="col-sm-12">
                    <div style="display: flex;justify-content: center;">
                        <mat-spinner [diameter]="30"></mat-spinner>
                    </div>
                </div>
            </div>
        </div>
    </div>



</div>

<div class="container" *ngIf="!finishedLoadingUsers">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>